/*
  International order request form — submit without leaving the page.

  {% form 'contact' %} posts the whole page and comes back at
  ?contact_posted=true. On a standalone page that is merely abrupt; inside a
  modal it reads as the dialog flashing and closing, with the confirmation
  landing somewhere the customer never sees. So the submit is intercepted and
  the same POST is made in the background.

  Bound once, on document, rather than on each form: the theme opens modals by
  copying a hidden div's innerHTML into #modal-common, and a listener attached
  to the original node does not survive the copy. Delegation does.
*/
(function () {
  if (window.__intlOrderFormBound) return;
  window.__intlOrderFormBound = true;

  var SENDING_LABEL = 'Sending…';

  function alertMarkup(message) {
    return (
      '<span class="alert alert--error alert--icon"><span>' +
      message +
      '</span></span>'
    );
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    var root = form.closest('[data-intl-order-form]');
    if (!root) return;

    event.preventDefault();

    var fields = root.querySelector('[data-intl-fields]');
    var done = root.querySelector('[data-intl-done]');
    var alertBox = root.querySelector('[data-intl-alert]');
    var button = form.querySelector('[type="submit"]');
    var label = form.querySelector('[data-intl-submit-label]');
    var originalLabel = label ? label.textContent : '';

    if (alertBox) {
      alertBox.hidden = true;
      alertBox.innerHTML = '';
    }
    if (button) button.disabled = true;
    if (label) label.textContent = SENDING_LABEL;

    var restore = function () {
      if (button) button.disabled = false;
      if (label) label.textContent = originalLabel;
    };

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'text/html' },
    })
      .then(function (response) {
        return response.text().then(function (html) {
          return { url: response.url || '', html: html };
        });
      })
      .then(function (result) {
        if (result.url.indexOf('contact_posted=true') > -1) {
          if (fields) fields.hidden = true;
          if (done) {
            done.hidden = false;
            done.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
          return;
        }

        // Shopify re-renders the page with its own alert when a field is
        // rejected. Lift that markup across rather than inventing wording of
        // our own, so the message matches what the no-JS path would show.
        var parsed = new DOMParser().parseFromString(result.html, 'text/html');
        var serverAlert = parsed.querySelector('.alert--error');
        if (serverAlert && alertBox) {
          alertBox.innerHTML = serverAlert.outerHTML;
          alertBox.hidden = false;
          alertBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          restore();
          return;
        }

        // Neither a success redirect nor a recognisable error — most likely
        // Shopify has put a reCAPTCHA challenge in the way, which only works as
        // a real page. Hand the form back to the browser and let it through.
        restore();
        form.submit();
      })
      .catch(function () {
        if (alertBox) {
          alertBox.innerHTML = alertMarkup(
            'Your request could not be sent. Please check your connection and try again.'
          );
          alertBox.hidden = false;
        }
        restore();
      });
  });
})();
